import { createFileRoute } from '@tanstack/react-router';

import { ResetPasswordPage } from '../auth/reset-password-page';
import { useAppNavigate } from '../lib/session/navigate';

/**
 * `/reset-password` (ask) and `/reset-password?token=…` (set a new one).
 *
 * The token is read from the URL and passed straight through. It is never stored, never
 * logged and never put in a message.
 */

interface ResetSearch {
  token?: string;
}

export const Route = createFileRoute('/reset-password')({
  validateSearch: (search: Record<string, unknown>): ResetSearch =>
    typeof search['token'] === 'string' && search['token'] !== '' ? { token: search['token'] } : {},
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = Route.useSearch();
  const navigate = useAppNavigate();

  return (
    <ResetPasswordPage
      {...(token === undefined ? {} : { token })}
      redirectTo="/reset-password"
      onNavigate={navigate}
    />
  );
}
